import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { 
    // Map,
    OrderedMap
} from "immutable";
import {
    Row,
    Col,
    List as AntList,
    Card,
    Statistic,
    Button,
    Select,
    message
} from "antd";

import { fetchScoreCard, generateScoreCard, fetchCaseSupplyChainDetails } from "store/actions";
import CaseService from "services/case-service";
import "styles/financial-analysis-table.css";
import { STATE_STATUS, SCORECARD_TYPE } from "constants/index";

const ListItem = AntList.Item;
const Option = Select.Option;
// const ListItemMeta = AntList.Item.Meta;

const getFixedValue = (value, label) => {
    if(value && !isNaN(value)) {
        if(label.includes("%")) {
            return `${parseFloat(value).toFixed(2)} %`;
        }
        return parseFloat(value).toFixed(2);
    }
    return value;
};

const ScoreTable = props => {
    return (
        <AntList className={"score-card-list"} itemLayout={"vertical"}>
            {props.score
                .map(_ => (
                    <ListItem key={_.label} className={_.className}>
                        <ListItem.Meta title={_.label} />
                        <div className={"d-flex justify-content-space-between"}>
                            <Statistic
                                title="Actual Score"
                                value={_.actual_score.value}
                                precision={2}
                                suffix={`/ ${_.actual_score.suffix}`}
                            />
                            <Statistic
                                title="Weighted Score"
                                value={_.weighted_score.value}
                                // suffix={`/ ${_.weighted_score.suffix}`}
                                precision={2}
                            />
                        </div>
                    </ListItem>
                ))
                .toList()
                .toArray()}
            <ListItem key={"total"} className={"color-blue-highlight"}>
                <ListItem.Meta title={"Score"} />
                <div className={"d-flex justify-content-flex-end"}>
                    <Statistic
                        value={props.score
                            .toList()
                            .map(_ =>
                                _.weighted_score ? _.weighted_score.value : 0
                            )
                            .reduce((_, agg) => _ + agg, 0)}
                        suffix={"/1000"}
                        precision={2}
                    />
                </div>
            </ListItem>
        </AntList>
    );
};

ScoreTable.propTypes = {
    score: PropTypes.object
};


export const SUPPLY_CHAIN_SCORE_CARD_MAP = new OrderedMap({
    "Level of Engagement in Sales": {
        label: "Level of Engagement (# Avg Monthly Sales)",
        value: null
    },
    "Level of Engagement in Repayment": {
        label: "Level of Engagement (# Avg Monthly Repayments)",
        value: null
    },
    "Number of Transactions with DPD > 0 (%)": {
        label: "Number of Transactions with DPD > 0 (%)",
        value: null
    },
    "Number of Transactions with DPD > 30 (%)": {
        label: "Number of Transactions with DPD > 30 (%)",
        value: null
    },
    "Number of Transactions with DPD > 60": {
        label: "Number of Transactions with DPD > 60 (%)",
        value: null
    },
    "Number of Transactions with DPD > 90": {
        label: "Number of Transactions with DPD > 90 (%)",
        value: null
    },
    "Dependence of Seller on Buyer": {
        label: "Dependence of Seller on Buyer",
        value: null
    }
});
class ScoreCard extends React.Component {
    state = {
        scorecard_type: 2
    };
    componentDidMount() {
        if (
            !this.props.scorecard ||
            this.props.scorecard.get("status") === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchScoreCard(this.props.caseId, 1);
            this.props.fetchScoreCard(this.props.caseId, 2);
        }

        if (this.props.supplyChainStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseSupplyChainDetails(this.props.caseId);
        }
    }
    selectScorecard = val => {
        this.setState(
            {
                scorecard_type: val
            },
            () =>
                this.props.fetchScoreCard(
                    this.props.caseId,
                    this.state.scorecard_type
                )
        );
    };
    generateScoreCard = () => {
        this.props.generateScoreCard(
            this.props.caseId,
            this.state.scorecard_type
        );
    };

    downloadFile = () => {
        message.info("Downloading... ", 2);
        CaseService.downloadScoreCard(this.props.caseId, this.state.scorecard_type).then((res) => {
            var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = `Scorecard-${this.props.caseId}.xlsx`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            message.success("File Download Successfully");
        });
    }

    render() {

        let scorecardDetails = this.props.scorecard.getIn([
            this.state.scorecard_type,
            "data",
            "details"
        ]);

        if(this.state.scorecard_type === 1) {
            scorecardDetails = SUPPLY_CHAIN_SCORE_CARD_MAP.map((_, k) => {
                let param = scorecardDetails && scorecardDetails.find(__ => __.label === k);
                _.value = (param && param.value) || "0";
                _.group = (param && param.group) || 1;
                _.optionLabel = (param && param.optionLabel) || "";
                return _;
            });
        }

        return (
            <Row className={"p-5"}>
                <Col
                    span={24}
                    className={
                        this.props.scorecard &&
                        this.props.scorecard.getIn([
                            this.state.scorecard_type,
                            "data",
                            "details"
                        ])
                            ? "d-flex justify-content-flex-end p-10"
                            : "d-flex h-100 fb-100 justify-content-center align-items-center p-10"
                    }>
                    <Select
                        style={{ width: 200 }}
                        size={"small"}
                        className={"mr-5"}
                        onSelect={this.selectScorecard}
                        value={this.state.scorecard_type}
                        placeholder={"Select Scorecard Type"}>
                        {SCORECARD_TYPE.map((v, k) => (
                            <Option key={v} value={v}>
                                {k}
                            </Option>
                        ))
                            .toList()
                            .toArray()}
                    </Select>
                    {this.props.isUserAllowedToEdit ? <Button className={"mr-5"} size={"small"} type="primary" 
                        onClick={this.generateScoreCard}>
                        Generate
                    </Button> : null}
                    {/* <Button size={"small"} type="default" onClick={this.downloadFile}>
                        Download
                    </Button> */}
                    
                </Col>
                <Col span={16} className={"p-10"}>
                    {
                        // this.props.scorecard &&
                        // new Map(
                        //     this.props.scorecard.getIn([
                        //         this.state.scorecard_type,
                        //         "data",
                        //         "details"
                        //     ])
                        // )
                        scorecardDetails &&
                        scorecardDetails
                            .groupBy(_ => _.group)
                            .map((_, key) => (
                                <AntList
                                    bordered={false}
                                    className={"tabulated-list p-10"}
                                    itemLayout={"horizontal"}
                                    key={`${key} Risk`}
                                    header={`${
                                        (
                                            this.props.scorecard &&
                                            this.props.scorecard.getIn([
                                                this.state.scorecard_type,
                                                "data",
                                                "groups"
                                            ]) &&
                                            this.props.scorecard
                                                .getIn([
                                                    this.state.scorecard_type,
                                                    "data",
                                                    "groups"
                                                ])
                                                .find(_ => _.id === key) || {
                                                label: ""
                                            }
                                        ).label
                                    } Risk`}>
                                    {_.map(item => (
                                        <ListItem key={item.label}>
                                            <ListItem.Meta title={item.label} />
                                            {typeof item.value === "object" ? (
                                                <div>{`Min (${item.value && item.value.min}), Max (${item.value && item.value.max})`}</div>
                                            ): <div>{getFixedValue(item.value, item.label) || item.optionLabel}</div>}
                                        </ListItem>
                                    )).toList()}
                                    {this.props.supplyChain && key === 1 ? 
                                        this.props.supplyChain.supplyChainScoreCardList.map(item => (
                                            <ListItem key={item.label} className={"d-flex justify-content-space-between"}>
                                                <ListItem.Meta title={item.label} />
                                                {item.value}
                                            </ListItem>
                                        )).toList() 
                                        : null}
                                </AntList>
                            ))
                            .toList()
                            .toArray()}
                </Col>
                {this.props.scorecard &&
                this.props.scorecard.getIn([
                    this.state.scorecard_type,
                    "data",
                    "details"
                ]) ? (
                        <Col span={8} className={"p-10"}>
                            <Card className={"padless-card p-10 mb-10"}>
                                <ScoreTable
                                    className={"p-10"}
                                    score={new OrderedMap(
                                        this.props.scorecard &&
                                        this.props.scorecard.getIn([
                                            this.state.scorecard_type,
                                            "data",
                                            "score"
                                        ])
                                    ).map((value, key) => ({
                                        label: `${key} Risk`,
                                        actual_score: {
                                            value,
                                            suffix: 1000
                                        },
                                        weighted_score: {
                                            value:
                                            (this.props.scorecard
                                                .getIn([
                                                    this.state.scorecard_type,
                                                    "data",
                                                    "groups"
                                                ])
                                                .find(_ => _.label === key)
                                                .weight *
                                                value) /
                                            this.props.scorecard
                                                .getIn([
                                                    this.state.scorecard_type,
                                                    "data",
                                                    "groups"
                                                ])
                                                .map(_ => _.weight)
                                                .reduce((_, agg) => _ + agg, 0),
                                            suffix:
                                            this.props.scorecard
                                                .getIn([
                                                    this.state.scorecard_type,
                                                    "data",
                                                    "groups"
                                                ])
                                                .map(_ => _.weight)
                                                .reduce(
                                                    (_, agg) => _ + agg,
                                                    0
                                                ) * 10
                                        }
                                    }))}
                                />
                            </Card>
                        </Col>
                    ) : null}
            </Row>
        );
    }
}

ScoreCard.propTypes = {
    caseId: PropTypes.number,
    scorecard: PropTypes.object,
    fetchScoreCard: PropTypes.func,
    generateScoreCard: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    companyId: PropTypes.number,
    supplyChain: PropTypes.object,
    fetchCaseSupplyChainDetails: PropTypes.func,
    supplyChainStatus: PropTypes.string
};

const mapStateToProps = (state, props) => {
    return {
        scorecard: state.scorecard.get(props.caseId),
        supplyChain: state.supplyChain.getIn(["records", props.caseId, "data"]),
        supplyChainStatus: state.supplyChain.getIn([
            "records",
            props.caseId,
            "status"
        ])
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchScoreCard,
            fetchCaseSupplyChainDetails,
            generateScoreCard
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ScoreCard);
